import React from 'react';
import {GcIcon} from "./GcIcon";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";
import {CTAButton} from '@growcloud-io/dc/components/buttons/Buttons';

export const withMinimalGcSiteLayout = (WrappedComponent) => {

  return (class extends React.Component {

    constructor(props) {
      super(props);
    }

    render() {
      const {cards = []} = this.props;
      return (
        <>
          <WrappedComponent
            {...this.props}
          />
        </>
      )
    }
  })
}

export const withGcSiteLayout = (WrappedComponent) => {

  return (class extends React.Component {

    constructor(props) {
      super(props);
    }

    render() {
      const {cards = []} = this.props;
      return (
        <>
          <Stack direction={'row'} sx={newColumnStack(null, 'center', 'center')}>
            <GcIcon/>
            <ButtonGroup size="large" aria-label="Large button group">
              <Button key="home" onClick={() => {
                window.location.href = '/';
              }}>HOME</Button>
              <Button key="intgration" onClick={() => {
                window.location.href = '/how-it-works';
              }}>HOW IT WORKS</Button>
              <Button key="features" onClick={() => {
                window.location.href = '/features';
              }}>FEATURES</Button>
              <Button key="api" onClick={() => {
                window.location.href = '/api';
              }}>API</Button>
              <Button key="faq" onClick={() => {
                window.location.href = '/faq';
              }}>FAQ</Button>
              <Button key="resources" onClick={() => {
                window.location.href = '/resources';
              }}>RESOURCES</Button>
            </ButtonGroup>
          </Stack>
          <Stack direction={'row'} sx={newColumnStack(null, 'right', 'center')}>
            <CTAButton
              buttonColor="primary"
              buttonText={'LOGIN'}
              onClick={() => {
                window.location.href = `https://beta-id.growcloud.io/signup`;
              }}
            />
          </Stack>
          <WrappedComponent
            {...this.props}
          />
        </>
      )
    }
  })
}